/**
 * @link https://mui.com/material-ui/react-button-group/
 */

import {Button, ButtonGroup} from "@mui/material";
import React from "react";
import ShowCode from "../../helpers/ShowCode.js";

export default function FactureeButtonGroup() {
  return (
    <>
      <ButtonGroup variant="contained" aria-label="outlined primary button group">
          <Button>One</Button>
          <Button>Two</Button>
          <Button>Three</Button>
          <Button>Four</Button>
      </ButtonGroup>
      <br/>
      <br/>

      <ButtonGroup variant="outlined" aria-label="outlined primary button group">
          <Button>One</Button>
          <Button>Two</Button>
          <Button>Three</Button>
          <Button>Four</Button>
      </ButtonGroup>
      <br/>
      <br/>

      <ButtonGroup variant="text" aria-label="outlined primary button group">
          <Button>One</Button>
          <Button>Two</Button>
          <Button>Three</Button>
          <Button>Four</Button>
      </ButtonGroup>
      <br/>
      <br/>
      
      <ShowCode 
        codeString={`<>
  {/* Contained button group */}
  <ButtonGroup variant="contained" aria-label="contained button group">
    <Button>One</Button>
    <Button>Two</Button>
    <Button>Three</Button>
    <Button>Four</Button>
  </ButtonGroup>
  
  {/* Outlined button group */}
  <ButtonGroup variant="outlined" aria-label="outlined button group">
    <Button>One</Button>
    <Button>Two</Button>
    <Button>Three</Button>
    <Button>Four</Button>
  </ButtonGroup>
  
  {/* Text button group */}
  <ButtonGroup variant="text" aria-label="text button group">
    <Button>One</Button>
    <Button>Two</Button>
    <Button>Three</Button>
    <Button>Four</Button>
  </ButtonGroup>
</>`} 
        scope={{ React, Button, ButtonGroup }} 
      />
    </>
  )
}